import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import DatePicker from 'react-16-bootstrap-date-picker'
import fullstory from '../../../utils/constants/fullstory'

const renderTypableDatePickerInput = ({ input, meta, label, ...rest }) => {
  return (
    <div className="form-group">
      {label !== '' && <label>{label}</label>}
      <DatePicker
        {...rest}
        className={fullstory.classNames.dateInput}
        placeholder="MM/DD/YYYY"
        showClearButton={false}
        value={input.value}
        onBlur={input.onBlur}
        onChange={value => input.onChange(value ? moment(value).format('YYYY-MM-DD') : null)}
      />
      {meta.touched && meta.error && (
        <h6 className="text-danger small text-justify" style={{ marginTop: '5px' }}>
          {meta.error}
        </h6>
      )}
    </div>
  )
}

renderTypableDatePickerInput.propTypes = {
  input: PropTypes.any.isRequired,
  meta: PropTypes.any.isRequired,
  label: PropTypes.string,
}

renderTypableDatePickerInput.defaultProps = {
  label: '',
}

export default renderTypableDatePickerInput



// WEBPACK FOOTER //
// ./src/components/ui/forms/renderTypableDatePickerInput.js